import { render, staticRenderFns } from "./MdCurrentAppointment.vue?vue&type=template&id=6fdbdd7f&"
import script from "./MdCurrentAppointment.vue?vue&type=script&lang=js&"
export * from "./MdCurrentAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports